import { bcs } from "@iota/iota-sdk/bcs";
import {
  KIOSK_PURCHASE_CAP,
  KIOSK_TYPE,
  TRANSFER_POLICY_CREATED_EVENT,
  TRANSFER_POLICY_TYPE
} from "./types/index.js";
const KioskType = bcs.struct(KIOSK_TYPE, {
  id: bcs.Address,
  profits: bcs.u64(),
  owner: bcs.Address,
  itemCount: bcs.u32()
});
const KioskPurchaseCap = bcs.struct(KIOSK_PURCHASE_CAP, {
  id: bcs.Address,
  kioskId: bcs.Address,
  itemId: bcs.Address,
  minPrice: bcs.u64()
});
const TransferPolicyCreatedEvent = bcs.struct(TRANSFER_POLICY_CREATED_EVENT, {
  id: bcs.Address
});
const TransferPolicyType = bcs.struct(TRANSFER_POLICY_TYPE, {
  id: bcs.Address,
  balance: bcs.u64(),
  rules: bcs.vector(bcs.string())
});
export {
  KioskPurchaseCap,
  KioskType,
  TransferPolicyCreatedEvent,
  TransferPolicyType
};
//# sourceMappingURL=bcs.js.map
